module.exports = __webpack_public_path__ + "img/file-pdf.6b260235.svg";